import React from 'react';
import classnames from 'classnames';

const Button = (props) => {
	const { className, color, icon, href, loading, ghost, children, onClick } =
		props;

	const handleClick = (e) => {
		e.preventDefault();
		onClick(e);
	};

	let HtmlTag,
		updatedProps = Object.assign({}, props);

	if (href) {
		HtmlTag = 'a';
	} else {
		HtmlTag = 'button';
	}

	if (onClick) {
		delete updatedProps.onClick;
		updatedProps.onClick = (e) => handleClick(e);
	}

	return (
		<>
			<HtmlTag
				{...updatedProps}
				className={classnames(
					className,
					color ? 'sui-button-' + color : '',
					{
						'sui-button-onload': loading,
						'sui-button-ghost': ghost,
						'sui-button-icon': !children,
						'sui-button': !!children,
					}
				)}
			>
				{!loading && (
					<>
						{!!icon && <span className={icon} aria-hidden="true" />}
						{children}
					</>
				)}
				{!!loading && (
					<span
						className="sui-icon-loader sui-loading"
						aria-hidden="true"
					/>
				)}
			</HtmlTag>
		</>
	);
};

export default Button;
